import moment from "moment";
import axios from "axios";
import naturalSort from "javascript-natural-sort";
import moveDialogTemplate from "./move-device-dialog.html";
import './device-admin-actions/device-admin-actions.component';

function DeviceDetailsCtrl($log,
                           $stateParams,
                           $scope,
                           $state,
                           $window,
                           SessionsService,
                           DevicesService,
                           TenantsService,
                           LocationsService,
                           BeaconsService,
                           CommandsService,
                           TimezonesService,
                           IntegrationEvents,
                           DistributorsService,
                           sweet,
                           ProgressBarService,
                           $mdDialog,
                           ToastsService,
                           DateManipulationService,
                           $timeout,
                           ImageService) {
  "ngInject";

  const vm = this;
  vm.tenantId = $stateParams.tenantId;
  vm.customConfigJsonEditorOptions = {
    options: {
      mode: 'code',
      change: function () {
        try {
          // on each change, attempt to get the json text
          // if it excepts, it means it's invalid json
          let json = vm.customConfigJsonEditorInstance.get();
          if (json === vm.currentDevice.customConfiguration) {
            vm.customConfigurationPristine = true;
          } else {
            vm.customConfigurationPristine = false;
          }
          vm.buttonDisabled = false;
        } catch (E) {
          vm.buttonDisabled = true;
        }
      }
    }
  };

  vm.hoursOfOperationJsonEditorOptions = {
    options: {
      mode: 'code',
      change: function () {
        try {
          // on each change, attempt to get the json text
          // if it excepts, it means it's invalid json
          let json = vm.hoursOfOperationJsonEditorInstance.get();
          if (json === vm.currentDevice.hoursOfOperation) {
            vm.hoursOfOperationConfigurationPristine = true;
          } else {
            vm.hoursOfOperationConfigurationPristine = false;
          }
          vm.buttonDisabled = false;
        } catch (E) {
          vm.buttonDisabled = true;
        }
      }
    }
  };
  vm.tenantUrl = `/#/tenants/${vm.tenantId}/details`;
  vm.tenantOverlayUrl = `/#/tenants/${vm.tenantId}/overlays`;
  vm.backUrl = '';
  vm.backUrlText = '';
  vm.deviceId = $stateParams.deviceId;
  vm.fromDevices = $stateParams.fromDevices === "true";
  vm.currentDevice = {'beacon': {}};
  vm.locations = [];
  vm.commandEvents = [];
  vm.dayRange = 30;
  vm.deprovisioningReasonOptions = [
    "different_model_replacement",
    "retiring_device",
    "same_model_replacement"
  ];
  vm.selectedDeprovisioningReason = "different_model_replacement";
  vm.issues = [];
  vm.timezones = [];
  vm.selectedTimezone = undefined;
  // 0 = no logs, 4 = most logs possible
  vm.loggingLevelOptions = [0, 1, 2, 3, 4];
  [vm.startTime, vm.endTime] = DateManipulationService.createFormattedStartAndEndDateFromToday(30);
  vm.enrollmentEvents = [];
  vm.logoChange = false;
  vm.controlsModeOptions = ["visible", "invisible", "disabled"];
  vm.orientationOptions = ["0", "90", "180", "270"];
  vm.displayRatioOptions = ["16:9", "16:10", "4:3", "21:9", "3:2", "32:9", "none"];
  vm.extendedDisplayRatioOptions = ["32:9", "32:10", "8:3", "42:9", "6:2", "none"];
  vm.sleepControllerOptions = ["chrome-default", "rs232"];
  vm.expectedConnectionStateOptions = ["unset", "online", "offline", "intermittent"];
  vm.overlayChanged = false;
  vm.hoursOfOperationOverride = false;
  vm.admin = SessionsService.getIsAdmin();
  vm.isManagingOrgAdmin;
  vm.isTenantAdmin = SessionsService.isTenantAdmin(vm.tenantId);
  vm.tenants = ['Loading Tenants, please wait'];
  vm.chosenTenant;

  vm.overlayPositions = [
    {
      "name": 'Top-Left',
      "position": "topLeft"
    },
    {
      "name": 'Top-Right',
      "position": "topRight"
    },
    {
      "name": 'Bottom-Left',
      "position": "bottomLeft"
    },
    {
      "name": 'Bottom-Right',
      "position": "bottomRight"
    }
  ];
  vm.managingOrgName = '';
  vm.managingOrgId = '';
  vm.isTenant = SessionsService.getIsTenant();

  /////////////////////////////////////////////////
  // customConfiguration
  /////////////////////////////////////////////////
  vm.customConfigurationOptions = (customConfigJsonEditorInstance) => {
    vm.customConfigJsonEditorInstance = customConfigJsonEditorInstance
  };

  /////////////////////////////////////////////////
  // hoursOfOperation
  /////////////////////////////////////////////////
  vm.hoursOfOperationConfigurationOptions = (hoursOfOperationJsonEditorInstance) => {
    vm.hoursOfOperationJsonEditorInstance = hoursOfOperationJsonEditorInstance
  };

  /////////////////////////////////////////////////
  // Overlay
  /////////////////////////////////////////////////
  vm.checkForOverlayChanges = () => {
    // this updates the view when a user selects an overlay from the dropdown
    let changed = false;
    let currentDeviceOverlays = vm.currentDevice.overlayTemplate;
    let currentDeviceCopyOverlays = vm.currentDeviceCopy.overlayTemplate;
    let positions = ['topLeft', 'topRight', 'bottomRight', 'bottomLeft'];
    for (let pos of positions) {
      if (currentDeviceOverlays[pos] && currentDeviceCopyOverlays[pos]) {
        if (currentDeviceOverlays[pos].image) {
          if (currentDeviceOverlays[pos].image.name !== currentDeviceCopyOverlays[pos].name) {
              changed = true;
            }
          }
          if (currentDeviceOverlays[pos].size !== currentDeviceCopyOverlays[pos].size) {
            changed = true;
          }
          if (currentDeviceOverlays[pos].type !== currentDeviceCopyOverlays[pos].type) {
            if (currentDeviceOverlays[pos].type.includes('logo')) {
              if ((currentDeviceOverlays[pos].type + ": " + currentDeviceOverlays[pos].image.name) !== currentDeviceCopyOverlays[pos].type) {
                changed = true;
              }
            } else {
              changed = true;
          }
        }
      }
    }
    vm.overlayChanged = changed;
  };

  vm.navigateToTenantDetail = (evt) => {
    evt.preventDefault();
    SessionsService.setCurrentSelectedTenantCode(vm.currentDevice.tenant.code);
    setTimeout(() => {
      window.location.href = `/#/tenants/${vm.tenantId}/details`;
    }, 500);
  };

  vm.revertToTenantOverlay = (ev) => {
    ProgressBarService.start();
    vm.loadingOverlays = true;
    let tenantPromise = TenantsService.getTenantById($stateParams.tenantId);
    tenantPromise.then(function (tenant) {
      let currentTenantOverlays = tenant.overlayTemplate;
      if (currentTenantOverlays) {
        for (let each of ["topLeft", "topRight", "bottomRight", "bottomLeft"]) {
          if (currentTenantOverlays[each]["type"] === "logo") {
            currentTenantOverlays[each]["imageId"] = currentTenantOverlays[each].image.id;
          } else {
            currentTenantOverlays[each]["imageId"] = null;
          }
        }

        let promise = DevicesService.saveOverlaySettings(
          vm.deviceId,
          currentTenantOverlays.bottomLeft,
          currentTenantOverlays.bottomRight,
          currentTenantOverlays.topRight,
          currentTenantOverlays.topLeft,
          tenant.overlaysAvailable,
        );

        promise.then((res) => {

          let devicePromise = DevicesService.getDeviceById(vm.deviceId);
          devicePromise.then((currentDevice) => {
            if (vm.currentDevice.overlaysAvailable) {
              vm.currentDevice.overlayTemplate = currentDevice.overlayTemplate;
              for (let each of ["bottomRight", "topRight", "topLeft", "bottomLeft"]) {
                if (vm.currentDevice.overlayTemplate[each].type === null) {
                  vm.currentDevice.overlayTemplate[each].type = "none";
                }
              }
            }
            vm.currentDeviceCopy.overlayTemplate = angular.copy(vm.currentDevice.overlayTemplate)
            vm.loadingOverlays = false;
            ProgressBarService.complete();
            ToastsService.showSuccessToast('We saved your update.');
          });
        });

        promise.catch((res) => {
          ProgressBarService.complete();
          ToastsService.showErrorToast('Something went wrong');
        });
      } else {
        vm.loadingOverlays = false;
        ProgressBarService.complete();
        return sweet.show('Oops...', 'Your tenant does not have overlays enabled. ' +
          'Please enable overlays for your tenant before attempting to revert device overlay to tenant settings.', 'error');

      }
    });
  };

  vm.adjustOverlaysAvailable = (status) => {
    vm.currentDevice.overlaysAvailable = status
    ProgressBarService.start();
    let promise = DevicesService.save(vm.currentDevice);
    promise.then(() => {
      let devicePromise = DevicesService.getDeviceById(vm.deviceId);
      devicePromise.then((response => {
        vm.onGetDeviceSuccess(response);
        vm.getTenantImages();
        ProgressBarService.complete();
      }), response => vm.onGetDeviceFailure(response));
    });
  };

  vm.submitOverlaySettings = () => {
    let overlaySettings = JSON.parse(JSON.stringify(vm.currentDeviceCopy.overlayTemplate));
    ProgressBarService.start();
    vm.loadingOverlays = true;
    let promise = DevicesService.saveOverlaySettings(
      vm.deviceId,
      overlaySettings.bottomLeft,
      overlaySettings.bottomRight,
      overlaySettings.topRight,
      overlaySettings.topLeft,
      vm.currentDevice.overlaysAvailable
    );
    promise.then((res) => {
      let devicePromise = DevicesService.getDeviceById(vm.deviceId);
      devicePromise.then((currentDevice) => {
        vm.currentDevice.overlayTemplate = currentDevice.overlayTemplate;
        for (let each of ["bottomRight", "topRight", "topLeft", "bottomLeft"]) {
          if (vm.currentDevice.overlayTemplate[each].type === null) {
            vm.currentDevice.overlayTemplate[each].type = "none";
          }
        }
        vm.currentDeviceCopy = JSON.parse(JSON.stringify(vm.currentDevice));
        vm.currentDeviceCopy.overlayTemplate = JSON.parse(JSON.stringify(vm.currentDevice.overlayTemplate));
        vm.loadingOverlays = false;
        vm.overlayChanged = false;
        ProgressBarService.complete();
        ToastsService.showSuccessToast('We saved your update.');
      })
    });
    promise.catch((res) => {
      ProgressBarService.complete();
      ToastsService.showErrorToast('Something went wrong');
    });
  };

  vm.getTenantImagesAndRefreshDevice = () => {
    let devicePromise = DevicesService.getDeviceById(vm.deviceId);
    devicePromise.then((res) => {
      vm.onGetDeviceSuccess(res);
      vm.getTenantImages()

    });
    devicePromise.catch((res) => {
      vm.onGetDeviceFailure(res)
    })

  };

  vm.getTenantImages = () => {
    vm.OVERLAY_TYPES = [
      {size: null, type: "none", imageId: null},
      {size: null, type: "weather", imageId: null},
      {size: null, type: "datetime", imageId: null}
    ];

    ProgressBarService.start();
    let promise = ImageService.getImages(vm.tenantId);
    promise.then((res) => {
      vm.tenantImages = res;
      ProgressBarService.complete();
      for (let value of vm.tenantImages) {
        for (let sizeOption of ["small", "large"]) {
          let newValue = {
            name: value.name,
            type: "logo",
            size: sizeOption,
            imageId: value.id
          };
          vm.OVERLAY_TYPES.push(newValue);
        }
      }
      vm.OVERLAY_TYPES.sort(naturalSort);
    });

    promise.catch(() => {
      ProgressBarService.complete();
      ToastsService.showErrorToast("Something went wrong when retrieving your images.")
    })
  };


  ////////////////////////////////////////////////
  // Events and Issues Tab
  ////////////////////////////////////////////////
  vm.replaceIssueTime = function (issues) {
    for (let i = 0; i < issues.length; i++) {
      let each = issues[i];
      if (each.created) {
        each.created = DateManipulationService.utcFormattedString(each.created);
      }
      if (each.updated) {
        each.updated = DateManipulationService.utcFormattedString(each.updated);
      }
    }
  };

  vm.replaceCommandTime = function (issues) {
    for (let i = 0; i < issues.length; i++) {
      let each = issues[i];
      if (each.postedTime) {
        each.postedTime = DateManipulationService.utcFormattedString(each.postedTime);
      }
      if (each.confirmedTime) {
        each.confirmedTime = DateManipulationService.utcFormattedString(each.confirmedTime);
      }
    }
  };

  vm.localFromUtc = function (events) {
    for (let i = 0; i < events.length; i++) {
      let each = events[i];
      if (each.utcTimestamp) {
        each.utcTimestamp = DateManipulationService.utcFormattedString(each.utcTimestamp);
      }
    }
  };

  vm.copydeviceId = () => ToastsService.showSuccessToast('Device key copied to your clipboard');

  vm.copyCorrelationIdentifier = () => ToastsService.showSuccessToast('Correlation ID copied to your clipboard');

  // event tab
  vm.getIssues = function (device, epochStart, epochEnd, page) {
    ProgressBarService.start();
    let issuesPromise = DevicesService.getIssuesById(device, epochStart, epochEnd, page);
    return issuesPromise.then(function (data) {
      vm.replaceIssueTime(data.issues);
      vm.issues = data.issues;
      vm.previous_page = data.previous;
      vm.next_page = data.next;
      return ProgressBarService.complete();
    });
  };

  // command history tab
  vm.getEvents = function (deviceId, page) {
    ProgressBarService.start();
    let commandEventsPromise = DevicesService.getCommandEventsById(deviceId, page);
    commandEventsPromise.then(function (data) {
      vm.replaceCommandTime(data.events);
      vm.event_next_page = data.next;
      vm.event_previous_page = data.previous;
      vm.commandEvents = data.events;
      ProgressBarService.complete();
    });
  };

  vm.getEnrollmentEvents = function (deviceId) {
    ProgressBarService.start();
    let enrollmentEventsPromise = IntegrationEvents.getEnrollmentEvents(deviceId);
    enrollmentEventsPromise.then(function (data) {
      vm.enrollmentEvents = data;
      vm.localFromUtc(data);
      ProgressBarService.complete();
    });
  };

  vm.paginateCall = function (forward) {
    if (forward) {
      return vm.getIssues(vm.deviceId, vm.epochStart, vm.epochEnd, vm.next_page);

    } else {
      return vm.getIssues(vm.deviceId, vm.epochStart, vm.epochEnd, vm.previous_page);
    }
  };


  vm.initialize = function () {
    vm.epochStart = moment(vm.startTime, 'YYYY-MM-DD hh:mm A').unix();
    vm.epochEnd = moment(vm.endTime, 'YYYY-MM-DD hh:mm A').unix();
    let timezonePromise = TimezonesService.getCustomTimezones();
    timezonePromise.then(data => vm.timezones = data);

    vm.panelModels = DevicesService.getPanelModels();
    vm.panelInputs = DevicesService.getPanelInputs();

    vm.selectedDeprovisioningReason = "different_model_replacement";

    let devicePromise = DevicesService.getDeviceById(vm.deviceId);
    devicePromise.then((response => vm.onGetDeviceSuccess(response)), response => vm.onGetDeviceFailure(response));
    vm.getTenantImages();
    vm.getEvents(vm.deviceId);
    vm.getIssues(vm.deviceId, vm.epochStart, vm.epochEnd);
    vm.getEnrollmentEvents(vm.deviceId);
    vm.fetchTenant(vm.tenantId);
  };

  vm.fetchTenant = (tenantId) => {
    let tenantPromise = TenantsService.getTenantById(tenantId);
    tenantPromise.then(( response => vm.onGetTenantSuccess(response)), response => vm.onGetTenantFailure(response));
  };

  vm.onGetTenantSuccess = (tenant) => {
    vm.getTenantManagingOrgName(tenant);
    vm.managingOrgId = tenant.managingOrg;
  };

  vm.onGetTenantFailure = (tenant) => {
    ToastsService.showErrorToast('Oops. We were unable to fetch the tenant details for this device at this time.');
    let errorMessage = `Unable to get tenant ${tenant}.`;
    $log.error(errorMessage);
    return $state.go('main.devices');
  };

  vm.getTenantManagingOrgName = (tenant) => {
    let distributorPromise = DistributorsService.getById(tenant.managingOrg);
    distributorPromise.then((response => vm.onGetDistributorSuccess(response)), response => vm.onGetDistributorFailure(response));
  };

  vm.onGetDistributorSuccess = (distributor) => {
    vm.managingOrgName = distributor.name;
    vm.isManagingOrgAdmin = SessionsService.isManagingOrgAdmin(distributor.id);
  };

  vm.onGetDistributorFailure = (distributor) => {
    ToastsService.showErrorToast('Oops. We were unable to fetch the distributor details for this device at this time.');
    let errorMessage = `Unable to get distributor ${distributor}.`;
    $log.error(errorMessage);
    return $state.go('main.devices');
  };

  vm.onGetDeviceSuccess = (response) => {
    vm.currentDevice = response;


    if (vm.currentDevice.overlaysAvailable) {
      for (let each of ["bottomRight", "topRight", "topLeft", "bottomLeft"]) {
        if (vm.currentDevice.overlayTemplate[each].type === null) {
          vm.currentDevice.overlayTemplate[each].type = "none";
        }
      }
    }

    // This is why the state is being overwritten, with this line commented out the overlays are not being cleared.
    // Not sure why this is here. Have been trying to smoke test, nothing is catching fire.
    // vm.currentDeviceCopy = angular.copy(vm.currentDevice);

    if (vm.currentDevice.usageType === null || vm.currentDevice.usageType === undefined) {
      vm.selectedUsageType = 'None';
    } else {
      vm.selectedUsageType = vm.currentDevice.usageType;
    }

    if (vm.currentDevice.expectedConnectionState === null || vm.currentDevice.expectedConnectionState === undefined){
      vm.selectedExpectedConnectionState = vm.expectedConnectionStateOptions[0];
    } else {
      vm.selectedExpectedConnectionState = vm.currentDevice.expectedConnectionState;
    }

    if (vm.currentDevice.loggingLevel === null || vm.currentDevice.loggingLevel === undefined) {
      vm.selectedLoggingLevel = 2;
    } else {
      vm.selectedLoggingLevel = vm.currentDevice.loggingLevel;
    }

    if (response.timezone !== vm.selectedTimezone) {
      vm.selectedTimezone = response.timezone;
    }

    if (vm.tenantId === undefined) {
      vm.tenantId = vm.currentDevice.tenant.id;
    }

    if ($stateParams.fromDevices === "true") {
      vm.backUrl = '/#/devices';
      vm.backUrlText = 'Back to devices';
    } else {
      if (vm.currentDevice.isUnmanagedDevice === true) {
        vm.backUrl = `/#/tenants/${vm.tenantId}/unmanaged`;
        vm.backUrlText = 'Back to tenant unmanaged devices';
      } else {
        vm.backUrl = `/#/tenants/${vm.tenantId}/managed`;
        vm.backUrlText = 'Back to tenant managed devices';
      }
    }

    let locationsPromise = LocationsService.getLocationsBytenantId(vm.tenantId);
    return locationsPromise.then((data) => {
      vm.locations = data;
      return vm.setSelectedOptions();
    });
  };

  vm.onGetDeviceFailure = function (response) {
    ToastsService.showErrorToast('Oops. We were unable to fetch the details for this device at this time.');
    let errorMessage = `No detail for device_key ${vm.deviceId}. Error: ${response.status} ${response.statusText}`;
    $log.error(errorMessage);
    return $state.go('main.devices');
  };

  vm.setSelectedOptions = function () {
    if (vm.currentDevice.panelModel === null) {
      vm.currentDevice.panelModel = vm.panelModels[0];
      vm.currentDevice.panelInput = vm.panelInputs[0];
    } else {
      for (let i = 0; i < vm.panelModels.length; i++) {
        let panelModel = vm.panelModels[i];
        if (panelModel.id === vm.currentDevice.panelModel) {
          vm.currentDevice.panelModel = panelModel;
        }
      }
      for (let j = 0; j < vm.panelInputs.length; j++) {
        let panelInput = vm.panelInputs[j];
        let isParent = panelInput.parentId === vm.currentDevice.panelModel.id;
        if (isParent && panelInput.id.toLowerCase() === vm.currentDevice.panelInput) {
          vm.currentDevice.panelInput = panelInput;
        }
      }
    }
    if (vm.currentDevice.location !== null) {
      for (let k = 0; k < vm.locations.length; k++) {
        let location = vm.locations[k];
        if (location.key === vm.currentDevice.location.key) {
          vm.currentDevice.location = location;
        }
      }
    }
  };

  /////////////////////////////////////////////////
  // Properties Tab
  /////////////////////////////////////////////////

  vm.getControlConfigAuthUrl = () => {
    const e = location.hostname === 'localhost' ? 'local' : process.env.__environment__;

    switch(e) {
      case 'int':
        return `https://us-central1-skykit-player-int.cloudfunctions.net/launchCuiFromAC`;
      case 'qa':
        return `https://us-central1-skykit-player-qa.cloudfunctions.net/launchCuiFromAC`;
      case 'stage':
        return `https://us-central1-skykit-player-stage.cloudfunctions.net/launchCuiFromAC`;
      case 'prod':
        return `https://us-central1-skykit-player.cloudfunctions.net/launchCuiFromAC`;
      case 'local':
        return `https://us-central1-skykit-player-int.cloudfunctions.net/launchCuiFromAC`;
    }
  }

  vm.openControlConfig = async ($event) => {
    $event.stopPropagation();
    $event.preventDefault();
    try {
      const url = vm.getControlConfigAuthUrl();
      const json = {
        deviceKey: vm.currentDevice.id
      }
      const token = SessionsService.getIdToken();
      const response = await axios.post(url, json, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
  
      window.open(response.data, '_blank')
    } catch (error) {
      ToastsService.showErrorToast('Could not launch the Control Configuration beta app. Please reach out to Skykit Support.');
    }

  }

  vm.onUnifiedDesktopChange = () => {
    if(vm.currentDevice.unifiedDesktop){
      vm.currentDevice.displayRatio = '32:9';
      vm.currentDevice.orientationMode = '0';
    } else {
      vm.currentDevice.displayRatio = '16:9';
    }
    vm.onSaveDevice();
  };

  vm.onSaveDevice = function () {
    ProgressBarService.start();
    if (vm.currentDevice.location && vm.currentDevice.location.key !== undefined) {
      vm.currentDevice.locationId = vm.currentDevice.location.key;
      vm.currentDevice.zipcode = vm.currentDevice.location.postalCode;
    }
    if ((vm.currentDevice.panelModel) && (vm.currentDevice.panelModel.id !== undefined && vm.currentDevice.panelModel.id !== 'None')) {
      vm.currentDevice.panelModelNumber = vm.currentDevice.panelModel.id;
    }
    if ((vm.currentDevice.panelInput) && (vm.currentDevice.panelInput.id !== undefined && vm.currentDevice.panelInput.id !== 'None')) {
      vm.currentDevice.panelSerialInput = vm.currentDevice.panelInput.id.toLowerCase();
    }
    vm.currentDevice.timezone = vm.selectedTimezone;
    vm.currentDevice.usageType = vm.selectedUsageType;
    vm.currentDevice.expectedConnectionState = vm.selectedExpectedConnectionState;
    vm.currentDevice.loggingLevel = vm.selectedLoggingLevel;

    let promise = DevicesService.save(vm.currentDevice);
    return promise.then(vm.onSuccessDeviceSave, vm.onFailureDeviceSave);
  };

  vm.onSuccessDeviceSave = function () {
    ProgressBarService.complete();
    ToastsService.showSuccessToast('We saved your update.');
    let devicePromise = DevicesService.getDeviceById(vm.deviceId);
    devicePromise.then((response => vm.onGetDeviceSuccess(response)), response => vm.onGetDeviceFailure(response));
  };

  vm.onFailureDeviceSave = function (error) {
    ProgressBarService.complete();
    if (error.status === 409) {
      $log.info(
        `Failure saving device. Customer display code already exists for tenant: ${error.status } ${error.statusText}`);
      return sweet.show('Oops...', 'This customer display code already exists for this tenant. Please choose another.', 'error');
    } else {
      $log.error(`Failure saving device: ${error.status } ${error.statusText}`);
      return ToastsService.showErrorToast('Oops. We were unable to save your updates to this device at this time.');
    }
  };

  vm.fetchAllTenantsPaginated = function (limit, page) {
    let promise = TenantsService.fetchAllTenantsPaginated(limit, page);
    return promise.then((response => vm.getFetchSuccess(response)), response => vm.getFetchFailure(response));
  };

  vm.getFetchSuccess = function (response) {
    vm.tenants = response.tenants;
    vm.next = response.next;
    vm.previous = response.previous;
  };

  vm.getFetchFailure = function (response) {
    let errorMessage = `Unable to fetch tenants. Error: ${response.status} ${response.statusText}.`;
    return sweet.show('Oops...', errorMessage, 'error');
  };

  vm.selectTenant = (tenant) => {
    vm.chosenTenant = tenant;
  };

  vm.confirmDeviceMove = () => {
    vm.fetchAllTenantsPaginated(5000,1);
    let confirm = $mdDialog.confirm(
      {
        scope: $scope,
        preserveScope: true,
        template: moveDialogTemplate,
        // targetEvent: event, // this param is an ng-click $event, but this function is triggered by ng-sumbmit
        onRemoving: vm.clearChosenTenantState,
      }
    );

    return $mdDialog.show(confirm);
  };

  vm.clearChosenTenantState = function (event, removePromise) {
    vm.chosenTenant = undefined;
  };

  vm.moveDeviceCancelDialog = function () {
    $mdDialog.hide();
  };

  vm.onMoveDevice = function () {
    ProgressBarService.start();
    if(vm.chosenTenant && vm.chosenTenant.id && vm.chosenTenant.code){
      // Because code, not id, is what the PUT endpoint cares about.
      vm.currentDevice.tenantCode = vm.chosenTenant.code;
      let promise = DevicesService.save(vm.currentDevice);
      return promise.then(vm.onSuccessDeviceMove, vm.onFailureDeviceMove);
    }
    else {
      return ToastsService.showErrorToast('Oops. Please select a valid tenant to move the device to.');
    }
  };

  vm.onSuccessDeviceMove = function () {
    ProgressBarService.complete();
    ToastsService.showSuccessToast('We moved your device.');
    // make a copy of the data stored in the chosenTenant.id because $mdDialog.hide will clear it via onRemoving
    let newTenantId = vm.chosenTenant.id;
    $mdDialog.hide();
    return $state.go('main.editDevice', {
      deviceId: vm.currentDevice.id,
      tenantId: newTenantId
    });
  };

  vm.onFailureDeviceMove = function (error) {
    ProgressBarService.complete();
    $mdDialog.hide();
    $log.error(`Failure saving device: ${error.status } ${error.statusText}`);
    if (error && error.status === 400){
      return ToastsService.showErrorToast(error.data.message);
    }
    else {
      return ToastsService.showErrorToast(
        'Oops. We were unable to move your device. Please wait a while and try again.');
    }
  };


  vm.confirmDeviceDelete = () => {
    let confirm = $mdDialog.confirm(
      {
        title: 'Are you sure you want to delete this device?',
        textContent: [
          'BE SURE TO BACKUP PROOF OF PLAY RECORDS BEFORE CONTINUING;',
          'THEY WILL BE DELETED.',
          'This device will also be deleted from the Skykit CMS.',
        ].join(' '),
        targetEvent: event,
        ok: 'Delete',
        cancel: 'Cancel'
      }
    );
    let device_id = vm.currentDevice.id;
    let showPromise = $mdDialog.show(confirm);
    let success = () => vm.onConfirmDelete(device_id);
    let failure = () => vm.onConfirmCancel();
    return showPromise.then(success, failure);
  };

  vm.onConfirmDelete = function (device_id) {
    let success = function () {
      ToastsService.showSuccessToast('We processed your delete request.');
      return $window.history.go(-1);
    };
    let failure = function (error) {
      if (vm.checkIfPopError(error)) {
        let message = error.data.message;
        ToastsService.showErrorToast(message);
        return $log.error(`Delete device failure for device_key ${device_id}: ${error.status } ${error.statusText}`);
      } else {
        let friendlyMessage = `We were unable to complete your delete request at this time.`;
        ToastsService.showErrorToast(friendlyMessage);
        return $log.error(`Delete device failure for device_key ${device_id}: ${error.status } ${error.statusText}`);
      }
    };
    let deletePromise = DevicesService.delete(device_id);
    return deletePromise.then(success, failure);
  };

  vm.checkIfPopError = (error)=> {
    if (typeof error.data !== 'undefined'
        && typeof error.data.message !== 'undefined'
        && error.data.message.includes('Proof of Play')){
      return true;
    } else {
      return false;
    }
  };

  vm.onConfirmDeprovisionAndDelete = function (device_id, reason) {
    let success = function () {
      ToastsService.showSuccessToast('We processed your deprovision & delete request.');
      return $window.history.go(-1);
    };
    let failure = function (error) {
      if (error.status === 500){
        let friendlyMessage = `We were unable to complete your deprovision & delete request at this time.
        It appears that we do not have access to the directory API of this device's domain.`;
      ToastsService.showErrorToast(friendlyMessage);
      }
      else if (vm.checkIfPopError(error)) {
        let message = error.data.message;
        ToastsService.showErrorToast(message);
        return $log.error(`Delete device failure for device_key ${device_id}: ${error.status } ${error.statusText}`);
      }
      else {
        let friendlyMessage = `We were unable to complete your deprovision & delete request at this time.`;
        ToastsService.showErrorToast(friendlyMessage);
        return $log.error(`Delete device failure for device_key ${device_id}: ${error.status } ${error.statusText}`);
      }
    };
    let deletePromise = DevicesService.deprovision(device_id, reason);
    return deletePromise.then(success, failure);
  };

  vm.confirmDeviceDeprovision = () => {
    let reason = vm.selectedDeprovisioningReason;
    let confirm = $mdDialog.confirm(
      {
        title: 'Are you sure you want to deprovision and delete this device?',
        textContent: [
          'BE SURE TO BACKUP PROOF OF PLAY RECORDS BEFORE CONTINUING;',
          'THEY WILL BE DELETED.',
          'This device will be deprovisioned from Chrome Device Management with the reason ' + reason +
          ' and will also be deleted from the Skykit CMS.',
        ].join(' '),
        targetEvent: event,
        ok: 'Deprovision & Delete',
        cancel: 'Cancel'
      }
    );
    let device_id = vm.currentDevice.id;
    let showPromise = $mdDialog.show(confirm);
    let success = () => vm.onConfirmDeprovisionAndDelete(device_id, reason);
    let failure = () => vm.onConfirmCancel();
    return showPromise.then(success, failure);
  };

  vm.onConfirmCancel = () => ToastsService.showInfoToast('Your request has been cancelled.');

  vm.onProofOfPlayLoggingCheck = function () {
    if (vm.currentDevice.proofOfPlayLogging) {
      let noLocation = vm.currentDevice.location === null;
      let noDisplayCode = (vm.currentDevice.customerDisplayCode === null || vm.currentDevice.customerDisplayCode === '');
      if (noLocation) {
        sweet.show('Oops...', "You must have a Location to enable Proof of play.", 'error');
        return vm.currentDevice.proofOfPlayLogging = false;
      } else if (noDisplayCode) {
        sweet.show('Oops...', "You must have a Display code to enable Proof of play.", 'error');
        return vm.currentDevice.proofOfPlayLogging = false;
      } else {
        return vm.onSaveDevice();
      }
    } else {
      return vm.onSaveDevice();
    }
  };

  vm.onUpdateLocation = () => vm.onSaveDevice();

  vm.autoGenerateCustomerDisplayCode = function () {
    let newDisplayCode = '';
    if (vm.currentDevice.customerDisplayName) {
      newDisplayCode = vm.currentDevice.customerDisplayName.toLowerCase();
      newDisplayCode = newDisplayCode.replace(/\s+/g, '_');
      newDisplayCode = newDisplayCode.replace(/\W+/g, '');
    }
    vm.currentDevice.customerDisplayCode = newDisplayCode;
  };

  vm.onClickRefreshButton = function () {
    ProgressBarService.start();
    vm.startTime = DateManipulationService.convertToMomentIfNotAlready(vm.startTime);
    vm.endTime = DateManipulationService.convertToMomentIfNotAlready(vm.endTime);
    vm.epochStart = moment(vm.startTime, 'YYYY-MM-DD hh:mm A').unix();
    vm.epochEnd = moment(vm.endTime, 'YYYY-MM-DD hh:mm A').unix();
    vm.previous_page = null;
    vm.next_page = null;
    let issuesPromise = DevicesService.getIssuesById(vm.deviceId, vm.epochStart, vm.epochEnd);
    return issuesPromise.then((data => vm.onRefreshIssuesSuccess(data)), error => vm.onRefreshIssuesFailure(error));
  };

  vm.onRefreshIssuesSuccess = function (data) {
    vm.replaceIssueTime(data.issues);
    vm.issues = data.issues;
    vm.previous_page = data.previous;
    vm.next_page = data.next;
    ProgressBarService.complete();
  };

  vm.onRefreshIssuesFailure = function (error) {
    ProgressBarService.complete();
    ToastsService.showInfoToast('We were unable to refresh the device issues list at this time.');
    $log.error(`Failure to refresh device issues: ${error.status } ${error.statusText}`);
  };

  vm.overrideTenantHoursOfOperation = () => {
    vm.hoursOfOperationOverride = true;
  };

  vm.cancelOverrideTenantHoursOfOperation = () => {
    vm.hoursOfOperationOverride = false;
    vm.currentDevice.hoursOfOperation = null;
  };

  vm.onSaveBeaconUrl = function () {
    let urlValid = vm.currentDevice.beacon.beaconType === 'URL' && vm.currentDevice.beacon.url !== null &&
      vm.currentDevice.beacon.url !== '';
    if (urlValid) {
      vm.onBeaconUpdate(true)
    }
  };

  vm.onBeaconEnable = function () {
    if (vm.currentDevice.beacon.enabled) {
      let promise = TenantsService.getBeaconDefaults(vm.tenantId);
      return promise.then((response => vm.onGetBeaconSuccess(response)), response => vm.onGetBeaconFailure(response));
    }
    else {
      return vm.onBeaconUpdate(true);
    }
  };

  vm.onGetBeaconSuccess = function (response) {
    vm.currentDevice.beacon.beaconType = response.beaconTypeDefault;
    if (response.beaconTypeDefault === 'URL') {
      vm.currentDevice.beacon.url = response.beaconUrlDefault;
    }
    return vm.onBeaconUpdate(true);
  };

  vm.onGetBeaconFailure = function (response) {
    let errorMessage = `Beacon default error on tenantId ${vm.tenantId}: ${response.status} ${response.statusText}`;
    $log.error(errorMessage);
    ToastsService.showErrorToast('Oops. We were unable to fetch beacon default values.');
  };

  vm.onBeaconUpdate = function (allowOtherThanUID = false) {
    let UIDStyle = vm.currentDevice.beacon.beaconType === 'UID';
    if (allowOtherThanUID || UIDStyle) {
      ProgressBarService.start();
      let promise = BeaconsService.update(
        vm.currentDevice.beacon.id,
        vm.currentDevice.beacon.enabled,
        vm.currentDevice.beacon.beaconType,
        vm.currentDevice.beacon.url);
      return promise.then(vm.onSuccessUpdatingBeacon, vm.onFailureUpdatingBeacon);
    }
  };

  vm.onSuccessUpdatingBeacon = function () {
    ProgressBarService.complete();
    ToastsService.showSuccessToast('We saved your beacon update.');
  };

  vm.onFailureUpdatingBeacon = function () {
    ProgressBarService.complete();
    ToastsService.showErrorToast('Oops. We were unable to save your beacon update at this time.');
  };

  return vm;
}

export {DeviceDetailsCtrl}

